import { APP_SCREEN_ROUTES } from "../app/routes/screenRegistry";

function humanizeScreenKey(screenKey) {
  return String(screenKey || "")
    .split("-")
    .filter(Boolean)
    .map((part) => {
      if (/^\d+g$/i.test(part)) return part.toUpperCase();
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join(" ");
}

function humanizeRoleSlug(roleSlug) {
  return String(roleSlug || "")
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

const PUBLIC_PAGE_TITLES = {
  "/": "Home",
  "/about": "About",
  "/tournaments": "Tournaments",
  "/contact": "Contact",
  "/donate": "Donate",
  "/admin-login": "Admin Login",
  "/user-login": "User Login",
  "/donor-login": "Donor Login",
  "/student-login": "Student Login",
  "/session-timeout": "Session Timeout",
  "/payment-status": "Payment Status",
  "/giri-public-app-logs": "Application Logs",
  "/giri-public-user-logs": "Application Logs",
};

const APP_PAGE_TITLES = Object.fromEntries(
  APP_SCREEN_ROUTES.map(({ path, screenKey }) => [
    `/app/${path}`,
    humanizeScreenKey(screenKey),
  ]),
);

const APP_PAGE_TITLES_BY_PREFIX = Object.entries(APP_PAGE_TITLES).sort(
  ([a], [b]) => b.length - a.length,
);

export function resolvePageTitle(pathname) {
  const path = pathname || "/";

  if (PUBLIC_PAGE_TITLES[path]) {
    return PUBLIC_PAGE_TITLES[path];
  }

  if (APP_PAGE_TITLES[path]) {
    return APP_PAGE_TITLES[path];
  }

  const dashboardMatch = path.match(/^\/([^/]+)\/dashboard$/);
  if (dashboardMatch) {
    return `${humanizeRoleSlug(dashboardMatch[1])} Dashboard`;
  }

  if (path.startsWith("/app/")) {
    for (const [routePath, title] of APP_PAGE_TITLES_BY_PREFIX) {
      if (path === routePath || path.startsWith(`${routePath}/`)) {
        return title;
      }
    }
  }

  return null;
}
